module.exports = __webpack_public_path__ + "assets/img/vipIcon3.7ee9186c.png";